import { useContext, createContext } from 'react';

import { User } from '@/services/api/auth/get-my-user/get-my-user';

export type SignOutPayload = { hardRedirect: boolean };

type AuthContext = {
  userId?: string;
  user?: User;
  customerId?: string;
  isCollaborator: boolean;
  isAuthenticatingUser: boolean;
  signOut: (signOutPayload?: SignOutPayload) => void;
};

export const authContext = createContext<AuthContext>({
  isCollaborator: false,
  isAuthenticatingUser: false,
  signOut: notImplemented,
});

function notImplemented(): never {
  throw new Error('Missing AuthContextProvider');
}

export const useAuthContext = () => {
  return useContext(authContext);
};
